import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'SYNCHRONISATION',
  entryPoint: '/synchronisations',
  collectionName: 'synchronisations',
  querySearchListing: [
    ['*', ['property', ['name'] ]],
    { order: { id: 'asc' }, where: { success: false } }
  ],
  successMessageCreate: 'Synchronisation created',
  successMessageUpdate: 'Synchronisation updated',
  successMessageDelete: 'Synchronisation deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/synchronisation/triggers.js